<div class="unsupported-device-container" [dir]="languageService.getCurrentLang() === 'ar' ? 'rtl' : 'ltr'">
  <!-- Header -->
  <header class="pt-6 px-6 flex justify-center mt-16">
    <img src="icons/infraReg-logo.svg" alt="{{ 'UNSUPPORTED_DEVICE.LOGO_ALT' | translate }}" class="h-10 brightness-0 invert">
  </header>

  <!-- Main Content -->
  <section class="flex-1 flex flex-col items-center justify-center px-6">
    <!-- Illustration -->
    <div class="mb-8">
      <img src="icons/bg-unsupported.svg" alt="" class="w-80 h-80 object-contain">
    </div>

    <!-- Heading -->
    <h1 class="text-[26px] font-bold text-white mb-4 leading-tight text-center">
      {{ 'UNSUPPORTED_DEVICE.HEADING' | translate }}
    </h1>

    <!-- Subheading -->
    <p class="text-[16px] text-white/70 leading-relaxed text-center max-w-xs">
      {{ 'UNSUPPORTED_DEVICE.SUBHEADING' | translate }}
    </p>
  </section>

</div>
